import "./slider.css"

export const Slider1 = ({imgs}) => {
    return <div className="item1">
        <img src={imgs}/>
    </div>;
}